import React, { useState } from "react";
import styled from "styled-components";
import Questions from "./questions";
import AttachPersonalEmail from "./attachPersonalEmail";
import ConfirmText from "./confirmText";
import VerifyCode from "./verifyCode";
import CompleteOnboardingFooter from "./footer";

const Wrapper = styled.div`
  padding: 5% 25% 0 25%;
  width: 100%;
  overflow: hidden;
  @media (max-width: 1800px) {
    padding: 5% 20% 0 20%;
  }
  @media (max-width: 1600px) {
    padding: 5% 17.5% 0 17.5%;
  }
  @media (max-width: 1280px) {
    padding: 5% 10% 0 10%;
  }
  @media (max-width: 900px) {
    padding: 5% 5% 0 5%;
  }
`;

const CompleteGroupOnboardingPage = ({
  emailFromTypeform,
  workEmail,
  group,
  reportId,
  groupObj,
  typeformData,
  type,
}) => {
  const [step, setStep] = useState(0);
  const [attachPersonalEmailOption, setAttachPersonalEmailOption] = useState("yes");
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [canSendEmail, setCanSendEmail] = useState(false);
  const [show48hMessage, setShow48hMessage] = useState(false);

  if (show48hMessage) {
    return (
      <Wrapper>
        <div
          style={{
            margin: "0 auto",
            maxWidth: "640px",
            width: "100%",
            height: "100%",
            fontSize: "1.5rem",
          }}
        >
          Thanks for sharing that! We&apos;ll email you within 48 hours at{" "}
          <span style={{ textDecoration: "underline" }}>{email ? email : emailFromTypeform}</span> with your
          recommendation or any follow-up questions.
        </div>
      </Wrapper>
    );
  }

  if (type === "two-accounts-issue") {
    return (
      <Wrapper>
        <div
          style={{
            margin: "0 auto",
            maxWidth: "640px",
            width: "100%",
            height: "100%",
            fontSize: "1.5rem",
          }}
        >
          There seems to be a problem with your account. Please contact us at{" "}
          <span style={{ textDecoration: "underline" }}>info@predictabill.com</span>.
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {type === "attach-personal-email" && (
        <div style={{ position: "relative", display: "grid", minHeight: "240px" }}>
          <Questions
            step={step}
            stepToShow={0}
            title={
              "You already provided a work email address. Would you like to attach a personal email address to this account?"
            }
            options={[
              { value: "yes", label: "Yes" },
              { value: "no", label: "No, I want to use my work email address" },
            ]}
            value={attachPersonalEmailOption}
            setValue={setAttachPersonalEmailOption}
          />
          {attachPersonalEmailOption === "yes" ? (
            <AttachPersonalEmail step={step} stepToShow={1} setEmail={setEmail} setCanSendEmail={setCanSendEmail} />
          ) : (
            <ConfirmText
              step={step}
              stepToShow={1}
              title={
                "Got it. That is possible, but we need you to verify that it's really you. We'll email you now with a verification code."
              }
            />
          )}
          {attachPersonalEmailOption === "no" && (
            <VerifyCode
              title={"Please enter your verification code below to proceed."}
              step={step}
              setCode={setCode}
              stepToShow={2}
            />
          )}
        </div>
      )}
      {type === "re-verify-work-email" && (
        <div style={{ position: "relative", display: "grid", minHeight: "240px" }}>
          <ConfirmText
            step={step}
            stepToShow={0}
            title={`Someone has already attached a different personal email address to this account. In order to add ${emailFromTypeform} to this account, you'll need to re-verify ${workEmail}.`}
          />
          <VerifyCode
            title={"Please enter your verification code below to proceed."}
            step={step}
            setCode={setCode}
            stepToShow={1}
          />
        </div>
      )}
      <CompleteOnboardingFooter
        type={type}
        attachPersonalEmailOption={attachPersonalEmailOption}
        emailFromTypeform={emailFromTypeform}
        workEmail={workEmail}
        email={email}
        canSendEmail={canSendEmail}
        code={code}
        step={step}
        setStep={setStep}
        group={group}
        reportId={reportId}
        groupObj={groupObj}
        typeformData={typeformData}
        setShow48hMessage={setShow48hMessage}
      />
    </Wrapper>
  );
};

export default CompleteGroupOnboardingPage;
